export const MonthsEnum = {
    january: { label: 'January', value: 1 },
    february: { label: 'February', value: 2 },
    march: { label: 'March', value: 3 },
    april: { label: 'April', value: 4 },
    may: { label: 'May', value: 5 },
    june: { label: 'June', value: 6 },
    july: { label: 'July', value: 7 },
    august: { label: 'August', value: 8 },
    september: { label: 'September', value: 9 },
    october: { label: 'October', value: 10 },
    november: { label: 'November', value: 11 },
    december: { label: 'December', value: 12 }
  };
  